import React from "react"
import {Route, Redirect} from "react-router-dom"

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render = {(props) => (
                sessionStorage.getItem("jwt")
                ? 
                <Component 
                    {...props}
                    data={rest.data}
                    updateState={rest.updateState}  
                />
                : 
                <Redirect to="/login/"/> 
    )}/>
)

export default PrivateRoute